import "./TFDSelectAcademy.css";

import { Link } from "react-router-dom";

export default function TFDSelectAcademy() {
	return (
		<div className="tfd-select-academy-page">
			{/* 1) HERO / BANNER SECTION */}
			<section className="tf-hero-academy">
				<div className="hero-image-wrap">
					<img
						src="/images/select/academy-hero.jpg"
						alt="TFD Academy Hero"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
				</div>

				<div className="hero-content themeflat-container">
					<h1 className="hero-title wow fadeInUp animated">
						TFD SELECT ACADEMY
					</h1>
					<p className="hero-subtitle wow fadeInUp animated">
						Give your child the opportunity to learn, grow, and shine.
					</p>
					<Link to="/contact" className="flat-button wow fadeInUp animated">
						Register Now
					</Link>
				</div>
			</section>

			{/* 2) MAIN INFO SECTION */}
			<section className="tf-academy-info main-content">
				<div className="themeflat-container">
					{/* Row #1: "Why TFD Academy" on the left, an image on the right */}
					<div className="row align-items-center">
						<div className="col-md-6 wow fadeInLeft animated">
							<div className="title-box title-small-v2">
								<span className="sub-title">Why TFD Academy?</span>
								<h2 className="title-section">
									Shape the Future of Football in Perth
								</h2>
							</div>
							<p className="post">
								Join us in shaping the future of football in Perth—one player at
								a time. Enroll today and let the journey begin!
							</p>

							<p className="post">
								<strong>
									Give your child the opportunity to learn, grow, and shine.
								</strong>
								At Total Football Development in Perth, we are more than just a
								football academy—we are a community dedicated to nurturing young
								talent, fostering a love for the game, and building essential
								life skills through football.
							</p>

							<Link to="/contact" className="flat-button">
								Enroll Today
							</Link>
						</div>

						<div className="col-md-6 wow fadeInRight animated">
							<div className="image-wraper">
								<img
									src="/images/select/academy-info1.jpg"
									alt="TFD Academy Session"
									className="image-gr"
								/>
							</div>
						</div>
					</div>

					{/* Row #2: 8 bullet points in a "Benefit1"-style 2-column layout */}
					<div className="row mt-5">
						<div className="col-12">
							<div className="title-box center-title-box title-large">
								<h2 className="title-section wow fadeInUp animated">
									Why Choose Total Football Development?
								</h2>
							</div>
						</div>

						{/* We'll break the 8 points into 2 columns of 4 each */}
						<div className="col-md-6 benefit-column-left wow fadeInLeft animated">
							<div className="benefit-item">
								<h4 className="title-benefit">1. Expert Coaching Team</h4>
								<p className="description-benefit">
									Our experienced, qualified coaches bring a wealth of
									professional &amp; youth football knowledge to your child’s
									training.
								</p>
							</div>

							<div className="benefit-item mt-4">
								<h4 className="title-benefit">
									2. Comprehensive Player Development
								</h4>
								<p className="description-benefit">
									We focus on technical, tactical, and mental growth, ensuring
									success on and off the pitch.
								</p>
							</div>

							<div className="benefit-item mt-4">
								<h4 className="title-benefit">3. Pathways to Success</h4>
								<p className="description-benefit">
								Our connections in the football world provide opportunities for trials at some of the biggest clubs in Europe.
								</p>
							</div>

							<div className="benefit-item mt-4">
								<h4 className="title-benefit">
									4. State-of-the-Art Facilities
								</h4>
								<p className="description-benefit">
									Players train in a safe, professional environment using modern
									equipment and top-tier pitches.
								</p>
							</div>
						</div>

						<div className="col-md-6 benefit-column-right wow fadeInRight animated">
							<div className="benefit-item">
								<h4 className="title-benefit">5. Pathways to Success</h4>
								<p className="description-benefit">
									We connect young talent with professional clubs, scouts, and
									advanced development opportunities.
								</p>
							</div>

							<div className="benefit-item mt-4">
								<h4 className="title-benefit">
									6. For the Love of the game
								</h4>
								<p className="description-benefit">
								No matter what your playing history, if you love this game we will make you love it more.
								</p>
							</div>

						
						</div>
					</div>

					{/* CTA at bottom */}
					<div className="row mt-5">
						<div className="col-12 text-center">
							<Link
								to="/contact"
								className="flat-button big-cta-button wow fadeInUp animated"
							>
								Enroll in TFD Select Academy
							</Link>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
